module.exports = __webpack_public_path__ + "static/media/board_round.71550ab0.svg";